// extracted by css-extract-rspack-plugin
module.exports =  {"template26__container":"Template26-D_Lx__template26__container","student-answer":"Template26-qV_U__student-answer","model-answer":"Template26-igeL__model-answer"};